import { ThreeDotsVertical } from "@styled-icons/bootstrap";
import classNames from "classnames";
import styled from "styled-components";
import { QuickAction } from "types/Widget";

import { IconButton } from "./primitives";
import { Dropdown, DropdownButton } from "./primitives/Dropdown";
import { MODAL_INDEX, PreventDragClass, WidgetControlClass } from "./WidgetComponents";

interface QuickActionsProps {
  actions?: { [id: string]: QuickAction };
  dashboardActions: { [id: string]: () => void };
  quickActionData: { [id: string]: any };
  setQuickActionData: (setting: string, data: any) => void;
  widgetTypeId: string;
  widgetState: object;
  setWidgetState: (state: object, override?: boolean) => void;
}

export const WidgetQuickActions: React.FC<QuickActionsProps> = ({
  actions,
  quickActionData,
  setQuickActionData,
  dashboardActions,
  ...quickActionProps
}) => {
  return (
    <WidgetsActions>
      <Dropdown trigger={<WidgetsActionsContainer Icon={ThreeDotsVertical} />}>
        {actions &&
          Object.values(actions).map((Action, index) => {
            const actionId = Object.keys(actions).find((key) => actions[key] === Action) || "";
            return (
              <DropdownButton key={index}>
                {quickActionData && (
                  <Action
                    data={quickActionData[actionId]}
                    setData={setQuickActionData.bind(null, actionId)}
                    dashboardActions={dashboardActions}
                    {...quickActionProps}
                  />
                )}
              </DropdownButton>
            );
          })}
      </Dropdown>
    </WidgetsActions>
  );
};

const WidgetsActions = styled.div.attrs({
  className: classNames(PreventDragClass, WidgetControlClass),
})`
  position: absolute;
  right: calc(var(--widget-handle-size) / -2);
  top: calc(var(--widget-handle-size) / -2);
  width: var(--widget-handle-size);
  height: var(--widget-handle-size);
  z-index: ${MODAL_INDEX + 1};
`;

const WidgetsActionsContainer = styled(IconButton).attrs({
  className: classNames(PreventDragClass),
})`
  width: var(--widget-handle-size);
  height: var(--widget-handle-size);
`;
